window.GatewayAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.GatewayServer);


    self.getCustomSocialLinkSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/custom_social_link_settings', 'GET').then(function (result) {
            if (result && result.data && result.status === 200) {
                deferred.resolve(result.data);
            } else {
                deferred.reject(result);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getExternalToken = (code) => {
        const deferred = $q.defer();

        _protected.request(`external-token-generator/token/${code}`, 'GET')
            .then((res) => {
                if (res.data) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getZendeskToken = function () {
        var deferred = $q.defer();

        _protected.request('external-token-generator/token/ZENDESK', 'GET')
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    self.getZendeskMessagesToken = function () {
        var deferred = $q.defer();

        _protected.request('external-token-generator/token/ZENDESK_MESSAGES', 'GET')
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    self.signGoogleStaticMapsURL = function (url) {
        var deferred = $q.defer();

        var payload = {
            url: url
        };

        _protected.request('google-maps-static-api-signer/sign', 'POST', payload)
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };
};